import React from 'react'
import { getImages } from '../../Common/const'

const HomeAbout = () => {
    return (
        <>
            <section className='home-about-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 hab-left'>
                            <h2 className='xxl-title fw-300 text-start mb-2 wow reveal fadeInUp'>About Us</h2>
                            <ul className='hab-list'>
                                <li className='wow reveal fadeInUp'>
                                    <div className='d-flex'>
                                        <div className='hb-list-icon'>
                                            <img src={getImages('circle-icon.svg')} alt='icon' />
                                        </div>
                                        <div className='xs-title text-uppercase ps-4'>NATIONALLY RECOGNIZED AUTHORITY FOR EXOTIC AND COLLECTIBLE VEHICLE SALES & SERVICE</div>
                                    </div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='d-flex'>
                                        <div className='hb-list-icon'>
                                            <img src={getImages('circle-icon.svg')} alt='icon' />
                                        </div>
                                        <div className='xs-title text-uppercase ps-4'>FOUNDED IN 2014 AS A SERVICE DEPARTMENT WITH MULTIPLE MASTER TECHNICIANS. WE SERVICE CARS SENT TO US FROM ALL OVER THE COUNTRY</div>
                                    </div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='d-flex'>
                                        <div className='hb-list-icon'>
                                            <img src={getImages('circle-icon.svg')} alt='icon' />
                                        </div>
                                        <div className='xs-title text-uppercase ps-4'>ALL OF THE VEHICLES WE TRANSACT HAVE BEEN THOROUGHLY INSPECTED AND APPROVED BY OUR TECHNICIANS PRIOR TO BEING OFFERED FOR SALE</div>
                                    </div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='d-flex'>
                                        <div className='hb-list-icon'>
                                            <img src={getImages('circle-icon.svg')} alt='icon' />
                                        </div>
                                        <div className='xs-title text-uppercase ps-4'>WE OWN AND HOLD TITLE TO VIRTUALLY EVERY CAR WE SELL</div>
                                    </div>
                                </li>
                                <li className='wow reveal fadeInUp'>
                                    <div className='d-flex'>
                                        <div className='hb-list-icon'>
                                            <img src={getImages('circle-icon.svg')} alt='icon' />
                                        </div>
                                        <div className='xs-title text-uppercase ps-4'>WE WORK HARD FOR OUR 5-STAR GOOGLE REVIEWS AND STELLAR REPUTATION</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='col-lg-6 hab-right wow reveal fadeInRight'>
                            {/* <img src={getImages('about-us-video.jpg')}/> */}
                            <div className='home-about-video'>
                                <video className='video-background' width="100%"
                                    controls
                                    poster={getImages("about-us-video-poster.webp")}
                                >
                                    <source src={`${getImages('about-us-video.mp4')}`} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeAbout